/* Clear finished events in cached pages and in tabs left open. */
(() => {
  function refreshPublicEvents(now = Date.now()) {
    document.querySelectorAll('[data-pt-public-events]').forEach((root) => {
      root.querySelectorAll('.pt-public-events__venue').forEach((venue) => {
        const bookings = Array.from(venue.querySelectorAll('[data-event-end]'));
        bookings.forEach((booking) => {
          const end = Date.parse(booking.dataset.eventEnd);
          booking.hidden = !Number.isFinite(end) || now >= end;
        });
        const empty = venue.querySelector('.pt-public-events__empty');
        if (empty) empty.hidden = bookings.some((booking) => !booking.hidden);
      });
    });
  }
  refreshPublicEvents();
  if (!window.ptPublicEventsExpiryInitialized) {
    window.ptPublicEventsExpiryInitialized = true;
    setInterval(refreshPublicEvents, 60000);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) refreshPublicEvents();
    });
    document.addEventListener('shopify:section:load', () => refreshPublicEvents());
    document.addEventListener('click', (event) => {
      const link = event.target?.closest?.('header-drawer a[href="/#live-music"]');
      if (!link || location.pathname !== '/' || event.button !== 0 ||
          event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const drawer = link.closest('header-drawer');
      const summary = drawer.querySelector('#Details-menu-drawer-container > summary');
      if (summary && typeof drawer.closeMenuDrawer === 'function') {
        drawer.closeMenuDrawer(event, summary);
        summary.setAttribute('aria-expanded', 'false');
      }
    });
  }
})();
